

module.exports = __webpack_require__.stylable.create(
    "Ellipsis840800975",
    {"classes":{"root":"Ellipsis840800975__root","text":"Ellipsis840800975__text","tooltip":"Ellipsis840800975__tooltip"},"vars":{},"stVars":{},"keyframes":{}},
    ".Ellipsis840800975__text{white-space:nowrap!important;text-overflow:ellipsis!important;overflow:hidden!important;max-width:100%!important;display:inline-block!important;vertical-align:bottom!important}.Ellipsis840800975__tooltip{display:inline;overflow:hidden;height:max-content}.Ellipsis840800975__tooltip .Popover2751380931__popoverElement{max-width:100%}",
    4,
    "Ellipsis840800975",
    __webpack_require__.stylable.$
);
